import CurrentContractPage from "./CurrentContractPage";

export default CurrentContractPage;
